/**
 * Find index of the closest number in array
 *
 * Expect
 *
 * @param num
 * @param arr
 */
import {LabelItem} from "../../model/items/labelItem";
import m from "mithril";
import {Questionary} from "../../model/questionary";

export function closestNumberIndex(num: number, arr: number[]) {
    let mid;
    let lo = 0;
    let hi = arr.length - 1;
    while (hi - lo > 1) {
        mid = Math.floor ((lo + hi) / 2);
        if (arr[mid] < num) {
            lo = mid;
        } else {
            hi = mid;
        }
    }
    if (num - arr[lo] <= arr[hi] - num) {
        return lo;
    }
    return hi;
}


/**
 * Get horizontal percent offset from element, accept MouseEvent or TouchEvent
 * _____________
 * |           | <-- HTML element
 * |   👆      | <-- cursor
 * L___^_______|
 *     30%
 *     result 0.3
 *
 * @param e
 * Return [0..1]
 */
export function getPercentOffsetXFromEvent(e: MouseEvent|TouchEvent): number {
    const clickOffset = (e instanceof MouseEvent) ? e.pageX : e.targetTouches.item(0)?.pageX || 0;
    const $el = $(<HTMLElement>e.currentTarget);
    const elOffset = $el.offset().left;
    const elWidth = $el.width();
    return Math.min(Math.max( (clickOffset-elOffset)/elWidth, 0 ), 1)
}

/**
 * Load data from label as JSON or take this label as URL to JSON file
 */
export function loadJsonFromLabel(label: LabelItem, onLoad: (data: any)=>void, onError?: (err: any)=>void): void {
    loadJsonFromString(
        label.childrenTags[0]?.value,
        label.questionary,
        onLoad,
        onError
    );
}

export function loadJsonFromString(urlOrJson: string|undefined, questionary: Questionary, onLoad: (data: any)=>void, onError?: (err: any)=>void): void {
    // No data
    if (!urlOrJson) {
        onLoad(undefined);
        return;
    }

    let data;
    // JSON directly
    try {
        data = JSON.parse(urlOrJson);
        onLoad(data);
        return;
    } catch (e) {
        // okay, it is probably link to file
    }

    const url = (urlOrJson.indexOf('http://') === 0 || urlOrJson.indexOf('https://') === 0) ? urlOrJson :questionary.getFileUrl(urlOrJson);

    // @ts-ignore (type harassment)
    m.request({
        url: url,
        responseType: "json",
    }).then(result => onLoad(result), reason => onError?.(reason));

}

/**
 * Normalize given string - remove
 * @param s
 */
export function normalizeString(s: string): string {
    // IE 11 fix
    if (s.normalize) {
        s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    return s.replace(/ +/, ' ').toLocaleLowerCase();
}


export function parseNumber(input?: string, min?: number, max?: number): number|undefined {
    min = min ?? -Infinity;
    max = max ?? +Infinity;
    if (min > max) [min, max] = [max, min];


    // Empty input
    if (!input) {
        return undefined;
    }

    // remove whitespace, replace ',' with '.'
    input = input.replace(/\s+/g, '').replace(',', '.');

    // check against numeric pattern
    if (!/^-?[0-9]*\.?[0-9]*$/.test(input)) {
        return undefined;
    }

    const parsed = Number(input);

    // Not a Number
    if (isNaN(parsed)) {
        return undefined;
    }

    // number out of range
    if (parsed < min || parsed > max) {
        return undefined;
    }

    return parsed;
}